import React, { useEffect, useMemo, useRef, useState } from 'react';
import NotificationAlert from "react-notification-alert";
import DataTable from 'components/Core/DataTable';
import Purchaser from "../../lib/Core/Backend/Controllers/Purchaser";
import Brand from 'lib/Core/Backend/Controllers/Brand'
import {Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import Notify from 'lib/Utils/Alert';
import { Ellipsis } from 'react-spinners-css';
import html2pdf from 'html2pdf.js';
import Utils from 'lib/Utils/Utils';

  const dollarUSLocale = Intl.NumberFormat('en-US', {
    style: "currency",
    currency: "USD",
	});

const BrandList = (props) => {
	const {token, brandPurchaser} = props;
  const purchaserCtl = useMemo(() => new Purchaser(token),[token]);
  const brandCtl = useMemo(() => new Brand(token),[token]);

  const [brandsLoading, setBrandsLoading] = useState(true);
  const [modal, setModal] = useState(false);

  const toggle = () => {setModal(!modal)};

  const table = useRef();
  const alert = useRef();
  const [loaderSave13, setLoaderSave13]=useState(false)
  const [loaderSave14, setLoaderSave14]=useState(false)


  const createTable = (data) => {
    let tbl = document.createElement("table");
		let tblHead = document.createElement('thead');
    let tblPurchaserHead = document.createElement('thead');
  	let tblBody = document.createElement("tbody");

		tbl.classList.add('table', 'table-bordered');
		tblHead.classList.add('thead-dark');
    tblPurchaserHead.classList.add('thead-dark');

		let headers = document.createElement('tr');
		let headerLabels = [
      `<div class= 'row'>
        <div class= 'col-4'>Brands</div>
        <div class= 'col-4'>Discount</div>
        <div class= 'col-4'>Fee</div>
      </div>`,
      'Card Types'];
		headerLabels.forEach(header => {
			let cell = document.createElement('th');
			cell.innerHTML = header;
			headers.appendChild(cell);

		});

    data.sort((a, b) => {
      var textA = a.name.toUpperCase();
      var textB = b.name.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    }).forEach((brand, brandIdx) => {
      let brandRow = document.createElement('tr');
      let brandName = document.createElement('th');
      brandName.setAttribute('rowspan', `${brand.cards.length === 0 ? 1 : brand.cards.length}`);
      brandName.setAttribute('scope', 'row');
      if(brandIdx % 2 === 0){
        brandName.classList.add('table-secondary');
      } else{
        brandName.classList.add('table-light')
      }
      brandName.innerHTML = `<div class= 'row'>
        <div class= 'col-4'>${brand.name}</div> 
        <div class= 'col-4'>${Utils.percentFormat(brand.purchaseDiscount/100)}</div>
        <div class= 'col-4'>${dollarUSLocale.format(brand.purchaseFee)}</div>
      </div>`;
      brandRow.appendChild(brandName);
      if(brand.cards.length === 0){
        let cardCell = document.createElement('td');
        cardCell.innerHTML = '';
        if(brandIdx % 2 === 0){
          cardCell.classList.add('table-secondary');
        } else{
          cardCell.classList.add('table-light')
        }
        brandRow.appendChild(cardCell);
        tblBody.appendChild(brandRow);
      } else {
        brand.cards.forEach((card, cardIdx) => {
          let cardCell;
          if(cardIdx === 0){
            cardCell = document.createElement('td');
            cardCell.innerHTML = `${card.productName} (${card.currency})`;
            brandRow.appendChild(cardCell);
            tblBody.appendChild(brandRow);
          } else {
            let row = document.createElement('tr');
            cardCell = document.createElement('td');
            cardCell.innerHTML = `${card.productName} (${card.currency})`;
            row.appendChild(cardCell);
            tblBody.appendChild(row);
          }
          if(brandIdx % 2 === 0){
            cardCell.classList.add('table-secondary');
          } else{
            cardCell.classList.add('table-light')
          }
        });
      }
      
    });

		tblHead.appendChild(headers);
    tbl.appendChild(tblPurchaserHead);
		tbl.appendChild(tblHead)
		tbl.appendChild(tblBody);
		return tbl;
  }

  const downloadPdf = () => {
    setLoaderSave14(true)
    let pdf = createTable(table.current.dataTable.data().toArray());

    var opt = {
      margin: [24, 15, 24, 15],
      filename:     `Available brands for Purchaser ${props.purchaser.name}.pdf`,
			image: {type: 'jpg', quality: 0.98},
			html2canvas: {scale: 2, logging: true, dpi: 192, letterRendering: true },
			jsPDF: {unit: 'mm', format: 'letter', orientation: 'portrait'},
			pagebreak: { mode: ['css'] }
    };
    html2pdf(pdf, opt)
    setTimeout(() => {
      setLoaderSave14(false)
    }, 1500)
  }

  const downloadCsvFile = () => {
    setLoaderSave13(true)
    let data = table.current.dataTable.data().toArray().sort((a, b) => {
      var textA = a.name.toUpperCase();
      var textB = b.name.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });


    let csv = [];
    
    data.forEach(brand => {
      if(brand.cards.length > 0){
        brand.cards.forEach(card => {
          const inventoryStatus = brand.inventoryStatus ? "Yes" : "No";
          csv.push(`"${brand.customerId}","${brand.customerName}","${brand.id}","${brand.name}","${card.productName}",${card.currency ?? 'N.A.'},${Utils.percentFormat(brand.purchaseDiscount/100)},${dollarUSLocale.format(brand.purchaseFee)},${brand.supplierName},${Utils.percentFormat(brand.supplierDiscount/100)},${inventoryStatus},`)
        })
      } else {
        csv.push(`${brand.name},No cards Available,,${Utils.percentFormat(brand.purchaseDiscount/100)},${dollarUSLocale.format(brand.purchaseFee)}`)
      }
    })

    csv = ` Customer Id, Customer Name , Brand Id, Brand name, Gift Card Type, Currency,  Purchaser Brand Discount, Purchaser Brand fee, Best Supplier ,Supplier Discount,Inventory\n${csv.join('\n')}`
    csv = `${props.purchaser.name}\n\n ${csv}`;

    const element = document.createElement("a");
		const file = new Blob([csv], {type: 'text/plain'});
		element.href = URL.createObjectURL(file);
		element.download = `Available brands for Purchaser ${props.purchaser.name}.csv`;
		document.body.appendChild(element); // Required for this to work in FireFox
		element.click();
    setTimeout(() => {
      setLoaderSave13(false)
    }, 1500)
  }

  useEffect(() => {
    if(props.purchaser.id){
      brandCtl.all(data => {
        setBrandsLoading(true)
        let brandLogos = [];
        data.result.forEach(brand => {
          brandLogos.push(
            {
              id: brand.id,
              logo: brandCtl.logo(brand.name, true)
            }
          );
        });
        purchaserCtl.availableBrands(props.purchaser.id, (data) => {
          
          
          if(data && !data.error){
  
            const discount = [];
            const fee = [];
            const purchaseBrands = [];
  
            for (var i = 0; i < data.brands.length; i++)
            {
              discount.push(data.brands[i]?.purchaseDiscount);
              fee.push(data.brands[i]?.purchaseFee);
              purchaseBrands.push(data.brands[i]?.id);
            }
  
  
          const brands = [];
          const sortedDiscount = [];
          const sortedFee = [];
  
          purchaserCtl.activeCards(props.purchaser.id, cardData => {
            Object.keys(data.brandList).forEach((brandId, idx) => {
  
                if (cardData && !cardData.error){
            
              for (var i = 0; i < purchaseBrands.length; i++)
              {
                  if (purchaseBrands[i] === parseInt(brandId))
                  {
                      sortedDiscount.push(discount[i]);
                      sortedFee.push(fee[i]);
                  }
  
              }
            
              const brand = data.brands.find((brand) => brand.id === parseInt(brandId))
                    brands.push(
                      {
                        id: brandId,
                        name: data.brandList[brandId],
                        customerName:props.purchaser.name,
                        purchaseFee: data.brands.purchaseFee,
                        purchaseDiscount: sortedDiscount[idx],
                        purchaseFee: sortedFee[idx],
                        purchaseFeeType: brand?.purchaseFeeType,
                        supplierName:brand.supplierName,
                        supplierDiscount:brand.supplierDiscount,
                        inventoryStatus:brand?.inventoryStatus,
                        customerId:props.purchaser.id, 
                        logo: brandLogos.find(logo => logo.id === parseInt(brandId)).logo || 'Not Found',
                        cards: cardData.filter(card => card.brandId === parseInt(brandId)),
                      }
                    );
                 
                  if(idx + 1 ===  Object.keys(data.brandList).length){
                    setBrandsLoading(false);
                    if(table.current){
                      const newBrands = brands.map((e) => {
                        for(let val of brandPurchaser){
                          if(e.id === val.brandId){
                            e.purchaseDiscount = val.purchaserDiscount;
                            e.purchaseFee = val.purchaserFee
                          }
                        }
                        return e
                      })
                      table.current.dataTable.clear().rows.add(newBrands).draw();
                    }
                  }
                } else {
                  Notify(alert, 'danger', cardData.error);
                }
              })
              
            });
            
          } else {
            Notify(alert, 'danger', data.error);
          }
        });
      }); 
    }
   
  },[brandCtl, purchaserCtl, props.purchaser.id]);
  return (
    <>
      <NotificationAlert ref={alert}/>
      <div id='content-brandList'>
      <Row className='justify-content-end'>
                    <Col md="auto">
                      <Button className="btn btn-primaryTwo" onClick={toggle}><i className="fas fa-download"/>{' '}view available brands</Button>
                    </Col>
                  </Row>
        <Row form className='justify-content-center mt-5'>
          <Col md="11" className="justify-content-end text-center">
              {brandsLoading && 
                
                <table className="table dataTable text-center">
                  <thead>
                    <tr>
                      <th className='px-3'>
                        <Ellipsis color="#73797d" />
                      </th>
                      <th className='px-3'>
                        <Ellipsis color="#73797d" />  
                      </th>
                      <th className='px-3'>
                        <Ellipsis color="#73797d" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colSpan={3}>
                        <Ellipsis color="#73797d" />
                      </td>
                    </tr>
                  </tbody>
                </table>
                
              }
              {!brandsLoading &&
                <>
                <div className="table-resonsive">
                  
                  <DataTable ref={table}
                    data={null}
                    columns={[
                      {
                        title: 'Logo', data: 'logo', render: (data, type, row) =>
                        {
                          let ret = "";
                          switch (type)
                          {
                            case "display":
                              ret = `<div class="ncentiva-brand-logo-block" style="background-image: url('${data}');"></div>`;
                              break;
                            case "type":
                              ret = "html";
                              break;
                            default:
                              ret = data;
                              break;
                          }
                          return ret;
                        },
                        width: "10%"
                      },
                      {
                        title: "Brand", data: "name", searchable: true, width: "15%"
                      },
                      {
                        title: "Fee",
                        data: "purchaseFee",
                        width: "10%",
                        render: (data, type, row) => {
                          if (data) {
                            if (row.purchaseFeeType === "PERCENTAGE") {
                              return Utils.percentFormat(data/100)
                            } else {
                              return dollarUSLocale.format(data);
                            }
                          }
                          return row.purchaseFeeType === "PERCENTAGE" ? '0%' : '$0.00';
                        }
                      },
                      {
                        title: "Discount", data: "purchaseDiscount", width: "10%", render: data => data ? Utils.percentFormat(data/100) : '0%'
                      },
                      {
                        title: "Card Types", data: "cards", render: (data) =>
                        {
                          if (data)
                          {
                            return "<ul class='overflow-hidden'>" + data.map(item =>
                            {
                              return `<li>${!!item.productName && !!item.currency ? `<div class="row" style="overflow: hidden"> <div class="col-4">${item.productName} </div><div class="col-4">(${item.currency}) </div><div class="col-4">SKU: (${!item.sku || item.sku === '' ? 'Not available' : item.sku}) </div></div>` : "Invalid card type"}</li>`;
                            }).join("") + "</ul>";
                          }
                          return "No card data found";
                        }
                      }
                    ]}
                    options={{
                      saveState: true,
                      searching: true,
                    }}
                    enableSelectFilters={true}
                  />
                  </div>
                 
                </>
              }
          </Col>
        </Row>
      </div>
      <Modal isOpen={modal} toggle={toggle} backdrop="static" size="md">
				<ModalHeader className="custom_header_colourTwo" toggle={toggle}>Available Brands</ModalHeader>
				<ModalBody>
					<Row className="mx-3">
						<Col md="6">
							<Button className="btn btn-primaryTwo" onClick={downloadCsvFile} disabled={loaderSave13}>
               Download excel file
							</Button>
						</Col>
						<Col md="6">
							<Button className="btn btn-primaryTwo" onClick={downloadPdf} disabled={loaderSave14}>
								Download PDF file
							</Button>
						</Col>
					</Row>
					
					
				</ModalBody>
				<ModalFooter>
					<Button color="secondary" onClick={toggle}>Close</Button>{' '}
				</ModalFooter>
			</Modal>
    </>
  );
}
 
export default BrandList;